import Vue from 'vue'
import StyleLoader from './components/StyleLoader'
import App from './App.vue'
import Axios from 'axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/ru-RU'
import VueFilter from 'vue-filter'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import VueYandexMetrika from 'vue-yandex-metrika'


Vue.use(VueYandexMetrika, {
  id: 2128321,
  env: 'production',
  options: {
    clickmap:true,
    trackLinks:true,
    accurateTrackBounce:true,
    webvisor:true
  }
});
// роутер
// import router from './router'

// флаг показа предупреждения о работе в режиме разработки
Vue.config.productionTip = false

// Axios
Vue.prototype.$http = Axios

Vue.use(ElementUI, {locale})
Vue.use(VueFilter)
Vue.use(VueReCaptcha, { siteKey: '6LfVdqobAAAAAJkXwwPs6lZ53_L69haP_Gz_WGZ7' })

// компонент, загружающий стили
{
  let wrapperElement = document.createElement('div')
  wrapperElement.id = 'vueStyleLoaderApplication'
  document.body.appendChild(wrapperElement)

  /* eslint-disable no-new */
  new Vue({
    el: '#' + wrapperElement.id,
    template: '<styleLoader id="vueStyleLoaderApplication"/>',
    components: {StyleLoader}
  })
}
// название свойства window c настройками Vue
const vueConfigName = 'vueConfig'

// Пример конфигурации
// window['vueConfig'] = {
//   applications: [
//     {
//       'name': 'routerApplication',
//       'element': 'vue-application',
//        'isUseRoute': true
//     },
//     {
//       // ...
//     }
//   ]
// }
// window['routerApplication'] = {
//   components: [
//     {
//       name: 'router',
//       data: {}
//     },
//     {
//       // ...
//     }
//   ]
// }

// Подключение приложений
do {
  if (!window[vueConfigName] || !window[vueConfigName].applications) {
    console.error('Не заданы настройки Vue')
    break
  }
  const applicationList = window[vueConfigName].applications
  if (!Array.isArray(applicationList)) {
    console.error('Свойство applications не является массивом')
    break
  }
  applicationList.forEach(function (application) {
    if (!application.element) {
      console.error('Не задан элемент для размещения приложения')
      return
    }
    if (!application.name) {
      console.error('Не задано название приложения')
      return
    }
    if (document.getElementById(application.element) !== null) {
      /* eslint-disable no-new */
      new Vue({
        el: '#' + application.element,
        // router, // Роутер
        template: '<App :application="application" :id="application.element"/>',
        components: {App},
        data: {
          application: window[application.name]
        }
      })
    } else {
      console.error('Элемент для размещения приложения не найден')
    }
  })
} while (false)



// WEBPACK FOOTER //
// ./src/vue/main.js